import { useAddResourceToPatient } from '_api/mutations';
import { AddResourceToPatientPayload, Resource } from '_api/types';
import { SEVERITY } from '_constants/derived';
import DefaultResourceToPatientSettings from '_constants/object-templates/DefaultResourceToPatientSettings';
import { AlertMessage, BaseModal } from 'components/molecules';
import { AddResourceToPatientForm } from 'components/organisms/forms';
import React, { useState } from 'react';

import { AddToPatientModalProps } from './types';

export const AddResourceToPatientModal = ({
  content,
  open,
  onClose,
  id,
}: AddToPatientModalProps<Resource>) => {
  const [errorMessage, setErrorMessage] = useState('');
  const [showSuccess, setShowSuccess] = useState(false);
  const { mutateAsync: addResourceToPatient } = useAddResourceToPatient();
  const [payload, setPayload] = useState<AddResourceToPatientPayload>(
    DefaultResourceToPatientSettings,
  );

  const close = () => {
    onClose();
    setPayload(DefaultResourceToPatientSettings);
  };

  const formatErrorMessage = (errorMessage: string) => {
    const regex =
      /patient with id '\d+' already has content type '(\w+)' for content with id '\d+'/i;
    const match = errorMessage.match(regex);
    if (match) {
      const contentType = match[1];
      if (content.title) {
        return `Patient already has ${contentType.toLowerCase()} '${content.title}'`;
      }
    }
    return errorMessage;
  };

  const onUpdate = async (key: any, arg: any) => {
    setPayload((current) => ({
      ...current,
      contentId: id,
      [key]: arg,
    }));
  };

  const onSubmit = () => {
    addResourceToPatient([payload] as AddResourceToPatientPayload[])
      .then(() => {
        setShowSuccess(true);
        setTimeout(() => onClose(), 1500);
      })
      .catch((error) => {
        if (error.response && error.response.status === 403) {
          setErrorMessage(
            'Unexpected error occured. Please close the modal and try again.',
          );
        } else if (error.message) {
          setErrorMessage(formatErrorMessage(error.message));
        } else {
          setErrorMessage('Unexpected error. Please Try again.');
        }
      });
  };

  return (
    content && (
      <BaseModal open={open} onClose={close} title={'Add To A Patient'}>
        <AddResourceToPatientForm
          initValue={payload}
          onBack={close}
          onSubmit={onSubmit}
          onUpdate={onUpdate}
        />
        <AlertMessage
          open={showSuccess}
          onClose={() => setShowSuccess(false)}
          message={`${content.title} successfully add to patient`}
        />
        <AlertMessage
          open={!!errorMessage}
          onClose={() => setErrorMessage('')}
          severity={SEVERITY.error}
          message={errorMessage}
        />
      </BaseModal>
    )
  );
};
